// import { Component, Input, OnInit } from '@angular/core';
// import * as Highcharts from 'highcharts';
// import { HttpClient } from '@angular/common/http';
// import { BarserviceService } from '../../barservice.service'
// import { Observable } from 'rxjs';
// import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
// import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
// import { ActivatedRoute, Router } from '@angular/router';

// @Component({
//   selector: 'app-barchart18-custom',
//   templateUrl: './barchart18.component.html',
//   styleUrls: []
// })
// export class Barchart18ComponentCustom implements OnInit {
//   chart: any;
//   event: any;
//   datalabel: any = false;
//   Highcharts: typeof Highcharts = Highcharts;
//   seriesData: any = [];
//   changeValue: any;
//   properties: any;
//   changeValueSeries: any;
//   significance: any;
//   changeValueSeriesUSA: any;
//   significanceUSA: any;
//   //data: any;
//   barChartData: any;
//   jsonData: any;
//   sampleSize: any;
//   min: any;
//   max: any;
//   significance2: any;
//   categories: any;
//   seriesObject: any = {};
//     maxSeries: any;
//     maxSeriesScreen: any;
//   pointWidthSize: any;
//   categoryImages: any;
//   maxDataPoints: any = 5;
//   @Input() popUp: any;
//   @Input() id: any;
//   @Input() height: any;
//   @Input() data: any; 
//   @Input() sort: any;
//   @Input() WidgetDetails: any;
//   @Input() customData: any;
//   @Input() isOutput: any;
//  constructor(private http: HttpClient, private _configService: SnapshotService, private route: ActivatedRoute, private barService: BarserviceService, private _customSnapshotService: CustomsnapshotService) { }
//   ngOnInit(): void {
//     // this.http.get<any>('../../../../../../assets/Data/barData.json').subscribe((data: any) => {
//     this.http.get<any>('assets/Data/clusterBarData.json').subscribe((data: any) => {
//       this.jsonData = data;
//       this.data = data[0];
//       this.barChartData = data[0]["data"];
//       this.properties = data[0]["properties"][0];

//       this.getBarChart('chart-container', this.seriesData, this.properties);
//     });

//   }
//   // customization(): Observable<any[]> {
//   //   return this.barService.VerticalClusterBarcustomizationList();
//   // }

//     customization(): Observable<any[]> {
//     // return this.barService.VerticalBarcustomizationList();
//       const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
//     const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience') 
//       ? this._configService.audienceCohortType 
//       : 'NA';
   
//     return this._customSnapshotService.getChartCustomization("Vertical Bar Chart ", this._customSnapshotService.selectedSnapshotType?.name,cohortType);

//   }

//   accessSeriesValues(seriesData: any, islowSample: any) {
//     const seriesObjects: any = {};
//     const categories: string[] = [];
//     const categorryImages: any[] = [];
//     const signi: any[] = [];
//     const signi2: any[] = [];
//     const changes: any[] = [];
//     const sampleSizeValues: any[] = [];

//     // Find unique series names
//     const uniqueSeriesNames = [...new Set(this.jsonData[0].data.map((series: { [x: string]: any; }) => series["Series Name"]))];
//     this.maxSeries = uniqueSeriesNames.length;
//     if (this.maxSeries > 15) {
//       this.maxSeriesScreen = 1;
//       this.pointWidthSize = 10;
//     } else if (this.maxSeries > 9) {
//       this.maxSeriesScreen = 2;
//       this.pointWidthSize = 15;
//     }
//     else if (this.maxSeries > 5 && this.maxSeries < 15) {
//       this.maxSeriesScreen = 3;
//       this.pointWidthSize = 10;
//     }
//     else {
//       this.maxSeriesScreen = 4;
//       this.pointWidthSize = 20;
//     }



//     uniqueSeriesNames.forEach(seriesName => {
//       const seriesData = this.jsonData[0].data.filter((series: { [x: string]: unknown; }) => series["Series Name"] === seriesName);
//       let iterationCount = 0;

//       seriesData.forEach((series: { [x: string]: string; Label: any; }) => {


//         const numericValue = (series["Value"] == null) ? 0 : Number(parseFloat(series["Value"]).toFixed(this.properties.decimalRoundOff));
//         const label = (series.Label);
//         const change = parseFloat(series["Change value vs PY"]);
//         const significance = parseFloat(series["Significance"]);
//         const significance2 = parseFloat(series["Significance2"]);
//         const category = series["Category Name"];
//         const categoryImage=series
//         const sampleSize = series["Sample size"];
//         const seriesName = series["Series Name"];
//         const roundedValue = series["Rounded Value"];
//         let finalvalue = !islowSample ? numericValue : (parseFloat(series['Sample size']) > this.barService.sampleSizeConstant ? numericValue : 0);
//         let samplesizevalue = parseFloat(series['Sample size']);
//         const tooltip = "";

//         if (!seriesObjects[seriesName]) {
//           seriesObjects[seriesName] = {
//             name: seriesName,
//             categoryName: category,
//             data: [],
//             label: [],
//             changeValue: [],
//             sampleSize: [],
//             significance: [],
//             significance2: [],
//             roundedValue:[],
//             visible: true,
//             tooltip:[]
//           };
//         }
//         seriesObjects[seriesName].sampleSize.push(samplesizevalue);
//         seriesObjects[seriesName].data.push(finalvalue);
//         seriesObjects[seriesName].label.push(label);
//         seriesObjects[seriesName].changeValue.push(change);
//         seriesObjects[seriesName].significance.push(significance);
//         seriesObjects[seriesName].significance2.push(significance2);
//         seriesObjects[seriesName].roundedValue.push(roundedValue);
//         seriesObjects[seriesName].tooltip.push(tooltip); // Push tooltip value to array
//         if (!categories.includes(category)) {
//           categories.push(category);
//         }


//         iterationCount++;
//       });

//     });

//     const firstSeriesName = uniqueSeriesNames.length > 0 ? uniqueSeriesNames[0] : null
//     const seriesData1 = this.jsonData[0].data.filter((series: { [x: string]: unknown; }) => series["Series Name"] === firstSeriesName);

//     this.categoryImages = seriesData1.map((series: { [x: string]: string; }) => series["Category Image"]);


//     this.categories = categories;
//     let i = 0;
//     this.seriesData = Object.values(seriesObjects).map((item: any) => {
//       return {
//         name: item.name,
//         data: item.data,
//         label: item.label,
//         pointPadding: 0.1,
//         groupPadding: 0.2,
//         zIndex: 2,

//         pointWidth: this.pointWidthSize,
//         color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],

//         roundedValue:item.roundedValue,
//         changeValue: item.changeValue,
//         significance: item.significance,
//         significance2: item.significance2,
//         sampleSize: item.sampleSize,
//         visible: item.visible,
//         showInlegend: item.showInLegend,
//         tooltip: {
//           enabled: true
//         }
//       };
//     });

//     let maxValue = Number.MIN_VALUE; // Initialize with the smallest possible value
//     let minValue = Number.MAX_VALUE; // Initialize with the largest possible value

//     // Loop through the collected data
//     for (const seriesName in seriesObjects) {
//       const seriesData = seriesObjects[seriesName];

//       // Check if the series has data
//       if (seriesData.data.length > 0) {
//         const seriesMaxValue = Math.max(...seriesData.data);
//         const seriesMinValue = Math.min(...seriesData.data);

//         // Update overall max and min values
//         maxValue = Math.max(maxValue, seriesMaxValue);
//         minValue = Math.min(minValue, seriesMinValue);
//       }
//     }
//     this.max = maxValue + Math.ceil(maxValue * 0.10);
//     this.min = minValue + Math.ceil(minValue * 0.10);
//   }

//   patternselect(ispattern: boolean) {
//     this.properties.showPattern = ispattern
//     this.accessSeriesValues(this.jsonData, this.properties.datalabelStyle == "ls");
//     this.getBarChart('chart-container', this.seriesData, this.properties);
//     ;
//   }

//   applycustomization(event: any, item: string) {
//     this.event = event;
//     //choose the appropriate customization
//     this.barService.applycustomization(event,item, this.properties)
//     this.getBarChart('chart-container', this.seriesData, this.properties);
//   }
//   getBarChart(containerid: string, seriesData: any, properties: any) {
//     localStorage.setItem("properties", JSON.stringify(this.properties));
//     this.accessSeriesValues(this.seriesData, this.properties.datalabelStyle == "ls");
//     let serviceBar = this.barService;



//     const updatedCategories = this.categoryImages;

//     const defaultCategories = this.categories;


//     const options:Highcharts.Options={
//       chart: {
//         type: 'column',
        
//         backgroundColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
//         style: {
//           fontFamily: this.barService.textfont,
//           color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
//         },
//         events:{
//           load: function(){
//             const chart = this;
//             //#region wheel scroll
//             const container = chart.container;
//             const xAxis = chart.xAxis[0];

//             function onWheel(e: any) {
//               e = e || window.event;
//               e.preventDefault();

//               // Normalize wheel delta
//               let delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
//               delta = delta > 0 ? -1 : 1; // reverse for natural scrolling

//               const extremes = xAxis.getExtremes();
//               const step = 1; // how many categories to scroll at a time

//               let newMin = extremes.min + delta * step;
//               let newMax = extremes.max + delta * step;

//               // Bound checks
//               if (newMin < extremes.dataMin) {
//                 newMin = extremes.dataMin;
//                 newMax = newMin + (extremes.max - extremes.min);
//               }
//               if (newMax > extremes.dataMax) {
//                 newMax = extremes.dataMax;
//                 newMin = newMax - (extremes.max - extremes.min);
//               }

//               xAxis.setExtremes(newMin, newMax, true, false);
//             }

//             container.addEventListener('wheel', onWheel, {
//               passive: false,
//             });
//             //#endregion
//           }
//         }
//       },
//       title: {
//         text:"",
//         align: this.properties.chartTitlePosition,
//         style: {
//           color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
//           marginleft: '4%',
//           fontSize: '2em',
//           fontFamily: this.barService.textfont
//         },
//       },
//       subtitle: {

//       },
//       exporting: {
//         enabled: false,
//       },
//       legend: this.barService.customizeLegend(this.chart, this.properties.showLegend, this.properties.legendPosition, this.properties),
//       xAxis: {

//         categories: defaultCategories,

//         min: 0,
//         //max: this.maxSeriesScreen,
//         max:undefined,
//         scrollbar: {
//           //enabled: defaultCategories.length > this.maxDataPoints ? true : false,
//           enabled:false,
//           height: 6, // Adjust the height of the scrollbar as needed
//           barBackgroundColor: '#7f7f7f',
//           barBorderRadius: 5,
//           barBorderWidth: 0,
//           barBorderColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
//           buttonBackgroundColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
//           buttonBorderWidth: 0,
//           buttonArrowColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
//           buttonBorderRadius: 5,
//           rifleColor: 'none',
//           trackBackgroundColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
//           trackBorderWidth: 0,
//           trackBorderColor: 'black',
//           trackBorderRadius: 5,

//         },
//         showEmpty: false,
//         labels: {

//           useHTML: true,
//           style: {
//             color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
//           },
//           formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {

//             if (properties.axisImage) {
//               let index = defaultCategories.indexOf(String(this.value));

//               const category = serviceBar.baseImgPath + updatedCategories[index] + '.png'

//               if (category) {
//                 return '<span style="display: inline-block; width: 2em; height: 2em; background: url(' + category + ') no-repeat center center; background-size: cover;"></span>';
//               } else {
//                 return '<span>No Image</span>';
//               }
//             } else {
//               return String(this.value);
//             }
//           },

//           rotation: this.barService.axisLabelOrientation(this.properties.axisLabelOrientation), // Rotate labels by -90 degrees (or any other desired angle)
//         }
//       },
//       yAxis: {

//         gridLineWidth: this.properties.gridlines ? 1 : 0,
//         max: this.max,
//         min: this.min,
//         margin: 1,
//         plotLines: [{
//           value: 0,
//           width: 1
//         }],
//         accessibility: {
//           rangeDescription: 'Range: 0 to 100' // Update the accessibility range description
//         },
//         labels: {
//           format: this.properties.datalabelFormat == "percentage" ? '{value}%' : '{value}',
//           style: {
//             color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
//           },
//         },
//         title: {
//           text: '', // Set an empty string to hide the yAxis title
//         },
//       },
//       tooltip: {
//         enabled: true,
//         borderWidth: 0,
//         useHTML: true,
//         // shape: properties.toolTipStyle == "style1" ? 'square' : 'callout',
//         shadow: false,
//         backgroundColor: 'rgba(0,0,0,0)',

//         formatter: function (this: any) {
//           if (this.series.name === 'Marker1') return false;
//           let isDefaultTooltip = properties.toolTipStyle;
//           const dotColor = serviceBar.color1[this.point.x]; // Get the series color

//           const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
//           const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
//           const text = this.series.userOptions.tooltip[this.point.x]
//           if (isDefaultTooltip == "style1") {

//             const commonContent =
//               `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 2%; border-radius: 5px; margin: 0; background-color: ${backgroundcolor2};">` +
//               `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 1rem;">Tooltip Title</span>` +
//               `<span><strong>Series Name:</strong></span> ${this.series.name}<br>` +
//               `<span><strong>Category Name:</strong></span> ${defaultCategories[this.point.x]}<br>` +
//               `<span><strong>Value:</strong></span> ${text}`;



//             return commonContent + '</div>';
//           }
//           else {

//             const content =
//               `<div style="background-color: ${backgroundcolor}; padding: 10%; align-items: center; border: 1px solid ${dotColor}; width:120%">` +
//               `<div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%; margin-right: 5%;"> </div>` +
//               ` ${this.series.name}` +
//               `<div style="display: block; margin-top: 1%;"><strong>Value:</strong> ${text}</div>`;

//             return content + '</div>';


//           }




//         },
//       },
//       credits: {
//         enabled: false
//       },
//       plotOptions: {
//         series: {
//           borderWidth: 0,
//           //animation: this.properties.dataLabelPositionPPT == 'Inside Base' || this.properties.dataLabelPositionPPT == 'Center' || this.properties.dataLabelPositionPPT == 'Inside End' || this.properties.dataLabelPositionPPT == 'Outside End' ? false : true,
//           animation:false,
//         },
//         column: {

//           stacking: undefined,
//           shadow: this.properties.shadow ? {
//             color: this.barService.shadowColor,
//             offsetX: 1,
//             offsetY: 1,
//             opacity: 0.5,
//             width: 6,
//           } : false,
//           pointWidth: 5,

//           dataLabels:

//           {
//             style: {

//               backgroundColor: this.barService.transparentBackground,

//               textOutline: 'none',

//               color: this.properties.darkTheme ? (this.properties.dataLabelColor === 'default' ? 'white' : this.properties.dataLabelColor || this.barService.darkThemeTextColor)
//                 : (this.properties.dataLabelColor === 'default'
//                   ? 'black'
//                   : this.properties.dataLabelColor || this.barService.defaultThemeTextColor),
//               fontSize: this.properties.dataLabelSize,
//               fontWeight: "normal",

//             },

//             crop: false,
//             enabled: this.properties.showDataLabel,

//             inside: true,



//             verticalAlign: this.properties.dataLabelPosition,
//             allowOverlap: this.properties.dataLabelOverlap=="false"?false:true,

//             formatter: function (this: any) {


//               if (properties.datalabelStyle == "significance + changeVs") {

//                 let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
//                 let changeText = this.series.userOptions.changeValue[this.point.x];
//                 let sig = this.series.userOptions.significance[this.point.x];
//                 let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
//                 let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
//                 if (parseFloat(changeText) > 0) {
//                   changeText = "+" + changeText;
//                 }
//                 let finalText = '<span>' +
//                   '<span>' + text + '</span>' +
//                   (this.series.userOptions.roundedValue[this.point.x] != null && changeText ? '<span>&nbsp' +
//                     '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
//                     '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
//                   '</span>';

//                 this.series.userOptions.tooltip[this.point.x - 1] = finalText;
//                 return (
//                   finalText
//                 );

//               }
//               if (properties.datalabelStyle == "change") {

//                 let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
//                 let changeText = this.series.userOptions.changeValue[this.point.x];


//                 let finalText = '<span>' + text + "  " +
//                   (this.series.userOptions.roundedValue[this.point.x ] != null && changeText ? '<span>&nbsp' +
//                     '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
//                     '</span>' : '');
//                 this.series.userOptions.tooltip[this.point.x - 1] = finalText;

//                 return (
//                   finalText
//                 );

//               }

//               if (properties.datalabelStyle == "ls") {


//                 let text = parseFloat(this.series.userOptions.sampleSize[this.point.x]) > serviceBar.sampleSizeConstant ? this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText : serviceBar.lowSampleText;
//                 let finalText = '<b>' +
//                   text +
//                   '</b> ' +
//                   '<span style="opacity: 0.5"></span>';
//                 this.series.userOptions.tooltip[this.point.x - 1] = finalText;

//                 return finalText;
//               }
//               if (properties.datalabelStyle == "significance") {
//                 let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
//                 let sig = this.series.userOptions.significance[this.point.x];
//                 let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
//                 let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');

//                 let finalText = '<span >' + text + (this.series.userOptions.roundedValue[this.point.x ] != null ? '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span>' : '') + '</span>';
//                 this.series.userOptions.tooltip[this.point.x - 1] = finalText;
//                 return (
//                   finalText
//                 )


//               }
//               if (properties.datalabelStyle == "datalabel") {
//                 let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
//                 this.series.userOptions.tooltip[this.point.x - 1] = text;
//                 return (
//                   '<span >' + text + '</span>'
//                 );
//               }
//               if (properties.datalabelStyle == "default") {
//                 let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
//                 this.series.userOptions.tooltip[this.point.x - 1] = text;
//                 return (
//                   '<span >' + text + '</span>'
//                 );
//               }

//               if (properties.datalabelStyle == "significance2") {
//                 let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
//                 let changeText = this.series.userOptions.changeValue[this.point.x];
//                 let sig = this.series.userOptions.significance[this.point.x];
//                 let sig1 = this.series.userOptions.significance2[this.point.x];
//                 let sColor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
//                 let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');

//                 let changeColor = sig1 > 0 ? serviceBar.lowSignificance : sig1 < 0 ? serviceBar.highSignificance : (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor);



//                 if (parseFloat(changeText) > 0) {
//                   changeText = "+" + changeText;
//                 }

//                 let finalText = '<span>' + text +
//                   (this.series.userOptions.roundedValue[this.point.x] != null && changeText ? '&nbsp<span style="color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + ' "> ' +
//                     '<span style="font-size:' + serviceBar.changeValueFontSize + '; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
//                     '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
//                   '</span>';
//                 this.series.userOptions.tooltip[this.point.x - 1] = finalText;
//                 return (
//                   finalText
//                 );
//               }

//               return this.series.userOptions.roundedValue[this.point.x] != null ? this.y : serviceBar.nullValueText;

//             },

//           }
//         }
//       },
//       series: this.seriesData,
//     }
//     Highcharts.chart('chart-container', options);
//   }
//   userselectedproperties() {
//     this.data["properties"][0] = this.properties;
//     return JSON.stringify(this.data).toString();
//   }
//   getPatternForImage(imageUrl: any) {
//     return {
//       pattern: {
//         image: imageUrl,
//         aspectRatio: 9 / 4
//       }
//     };
//   }

// }




import { Component, OnInit, AfterViewInit, Input,SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, tap } from 'rxjs';
import { BarserviceService } from '../../barservice.service';
// import { StackchartServiceService } from '../../stackchart-service.service';
//import { BarserviceService } from '../../../../../modules/barchart/barchart/barservice.service';
import Stock from 'highcharts/modules/stock';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
Stock(Highcharts);

@Component({
  selector: 'app-barchart18-custom',
  template: '<div [id]="\'chart-container\' + id" [style.height]="dynamicHeight"></div>',
  styleUrls: ['./barchart18.component.scss']
})

export class Barchart18ComponentCustom implements OnInit, AfterViewInit {
   
  Highcharts: typeof Highcharts = Highcharts;
  chartMainData: any = [];
  changeValue: any;
  properties: any;
  changeValueSeries: any;
  significance: any;
  sampleSize: any;
 
  defaultCategories1: any;
  max: any;
  min: any;
  maxBarValue = 0;
  public seriesData1: any[] = [];
  jsonData: any;
  categories: any;
  labels: any;
  significance2: any;
  selectedColor: any = "#ff0000";
  maxDataPoints: any = 8;
  maxSeries: any;
 
  userselectedchartdata: any;
  categoryColorMap: { [key: string]: string } = {};

  seriesData: any[] = [];
  StackChartData: any[] = [];
  chart: any;
  custom: any[] = [];
  ChartProperties: any;
  event: any;
 
  chartCategories: any;
  categoryImages: any[] = [];
   @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = "24em";
  @Input() isOutput: any ;
  @Input() data: any; 
    hasCustomMetricIndex = false;
  hasCustomMetricSignificance = false;
  hasCustomMetricPercentage = false;
  
  // Dynamic height property based on popUp state
  get dynamicHeight(): string {
    return this.popUp ? '30rem' : this.height;
  }
  
 private subscriptions: Subscription = new Subscription();
  DefaultConfidenceLevel: any = "";
  significanceValue: any = "None";
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  configuredProperties: any;

  ngOnInit(): void {
   
    if(this.isOutput){
      console.log("customData",this.customData);
      this.configuredProperties = JSON.parse(this.customData.customizationProperties);
      
      
      const allMetrics = this.customData.metric;
      this.applyCustomMetricExtensions();
      console.log('RAW metric data:', JSON.stringify(allMetrics[0]?.metric_value?.[0], null, 2));

      this.customData = {
      ...allMetrics[0],
      metric_value: allMetrics.flatMap((m: any) => m.metric_value)
      };
      



      if (this.configuredProperties?.sort == "default") this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      
      this.properties = this.configuredProperties != undefined ? this.configuredProperties : {};
      
      // Prepare data in ngOnInit
      this.preparemainChartData(this.customData);

      // Create a data structure for getData
      const chartDataStructure = [{ data: this.chartMainData }];
      this.getData(chartDataStructure, this.properties.datalabelStyle == "ls");
      
      // Subscribe to config changes
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe(value => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }));
      this.subscriptions.add(
        this._configService.significanceValue.subscribe(value => {
          this.significanceValue = value;
          this.updateSig();
        }));
      
    }
    else{
       this.http.get<any>('assets/Data/clusterBarData.json').subscribe((data: any) => {
       
        this.jsonData = data;
        this.data = data[0];
        this.StackChartData = data[0]["data"];
        this.properties = data[0]["properties"][0];
        this.properties.decimalRoundOff = 2;
        this.properties.showLegend = true;
            const chartDataStructure = [{ data: this.StackChartData }];
    this.getData(chartDataStructure, this.properties.datalabelStyle == "ls");
        this.route.paramMap.subscribe((params) => {
          const userData = history.state.userData;
          this.userselectedchartdata = userData; // Use the userData object as needed
          if (this.userselectedchartdata?.widgetEditSelection) {
            if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
              this.properties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
            }
          }
        });
        //this.getData(this.jsonData, this.properties.datalabelStyle == "ls");

        this.renderChart2('chart-container' + this.id, this.seriesData1, this.properties);
      });
    }
  }

   private applyCustomMetricExtensions(): void {

    const metrics = this.customData?.metric_value || [];

    this.hasCustomMetricIndex = false;
    this.hasCustomMetricSignificance = false;
    this.hasCustomMetricPercentage = false;

    metrics.forEach((metric: any) => {

      const extensions = metric.extensionOptions || [];

      if (
        extensions.some((e: any) =>
          e.id === 'index' && e.selected
        )
      ) {
        this.hasCustomMetricIndex = true;
      }

      if (
        extensions.some((e: any) =>
          e.id === 'significance' && e.selected
        )
      ) {
        this.hasCustomMetricSignificance = true;
      }

      if (
        extensions.some((e: any) =>
          e.id === 'percentageSymbol' && e.selected
        )
      ) {
        this.hasCustomMetricPercentage = true;
      }
    });


  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['customData'] && !changes['customData'].firstChange) {
      this.ngOnInit();
    }
      if (changes['popUp'] && !changes['popUp'].firstChange) {
    setTimeout(() => {
      const docEle = document.getElementById('chart-container' + this.id);
      if (docEle != null) {
        docEle.innerHTML = '';
      }
      this.renderChart2('chart-container' + this.id, this.seriesData1, this.properties);
    }, 50); // slight delay to let DOM settle after popup close
  }
    
    console.log(JSON.parse(this.customData?.customizationProperties));
  }
  ngAfterViewInit(): void {
    // Render chart after view is initialized (only for isOutput mode)
    if(this.isOutput){
      // Use setTimeout to ensure DOM is ready
      setTimeout(() => {
        let docEle = document.getElementById('chart-container' + this.id);
        if (docEle != null) {
          docEle.innerHTML = '';        
        }
        
        this.renderChart2('chart-container' + this.id, this.seriesData1, this.properties);
      }, 0);
    }
  }

  
  extractKeyAfterPipe(key: string): string {
    if (key && typeof key === 'string' && key.includes('|')) {
      const parts = key.split('|');
      return parts.length > 1 ? parts[parts.length - 1].trim() : key.trim();
    }
    return key || '';
  }

  constructor(private http: HttpClient,  private cdr: ChangeDetectorRef,private barService: BarserviceService,   private _customSnapshotService: CustomsnapshotService, private _configService: SnapshotService, private route: ActivatedRoute) { }
 updateSig() {
    this.Sig_LowerLimt =
      this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
        ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
        : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
          ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
          : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_98
            : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
    this.Sig_UpperLimt =
      this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
        ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
        : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
          ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
          : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_98
            : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;
    
    // this.properties.datalabelStyle = this.significanceValue == "None" ? "default" : "sigChange";
    // this.properties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.properties.datalabelStyle;
      if (this.hasCustomMetricSignificance) {
        this.properties.datalabelStyle = "default";
      } else {
        this.properties.datalabelStyle =
          this.significanceValue == "None"
            ? "default"
            : "sigChange";
      }

      //this.properties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.properties.datalabelStyle;
      if (
        this._configService.isIndexSelected &&
        !this.hasCustomMetricIndex
      ) {
        this.properties.datalabelStyle = "index";
      } 
    this.preparemainChartData(this.customData);
    
    // Create a data structure for getData
    const chartDataStructure = [{ data: this.chartMainData }];
    this.getData(chartDataStructure, this.properties.datalabelStyle == "ls");

    let docEle = document.getElementById('chart-container' + this.id)
    if (docEle != null) {
      docEle.innerHTML = '';
    }

    this.renderChart2('chart-container' + this.id, this.seriesData1, this.properties);
  }

    getData(chartData: any, lowSample1: any) {
    if (this.isOutput) {
      // this.properties=this.configuredProperties!=undefined?this.configuredProperties:this.properties;
      let seriesData: any[] = [];
      let value = 0;
      let i = 0;
      let maxValue = 0;
      let minValue = 0;
      let j = -1;
      let finalValue = 0;


      chartData[0].data = this.chartMainData;

      //get the first series name
      const firstItem = chartData[0].data[0]['Series Name'];

      //get the category images
      this.categoryImages = chartData[0].data.map((item: { [x: string]: string }) => (item["Category Image"]));
      this.categoryImages = [''].concat(this.categoryImages);
      //extract all data matching the series name



// Get all unique series names
const allSeriesNames = Array.from(new Set(chartData[0].data.map((item: { [x: string]: string }) => item['Series Name'])));

// Initialize seriesData1 as an array
// Add this at line 845 after getting allSeriesNames
console.log('Unique series in data:', allSeriesNames);
console.log('Total series count:', this.seriesData1.length);
this.seriesData1 = [];

// Initialize min/max
this.max = 0;
this.min = 0;
const allCategories = Array.from(new Set(chartData[0].data.map((item: { [x: string]: string }) => item['Category Name'])));

// Loop through each series name
  allSeriesNames.forEach((seriesName: any, seriesIndex: any) => {
      const seriesData = chartData[0].data.filter((item: { [x: string]: string }) => item['Series Name'] === seriesName);
      
      // Calculate the min and max value for the y-axis for this series
      // maxValue = Math.max(...seriesData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
      // minValue = Math.min(...seriesData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
      // this.max = Math.max(this.max, maxValue + Math.ceil(maxValue * (this._configService.isRespondentLevel ? 0.10 : 0.20)));
      // this.min = Math.min(this.min, minValue + Math.ceil(minValue * (this._configService.isRespondentLevel ? 0.10 : 0.20)));

      // Prepare arrays for each property
      const categoryNames: string[] = [];
      const seriesNames: string[] = [];
      const isPercentArray: boolean[] = [];
      const yValues: number[] = [];
      const xValues: number[] = [];
      const indexValues: number[] = [];
      const actualIndexValues: any[] = [];

      allCategories.forEach((categoryName, categoryIndex) => {
        const item = seriesData.find((d: { [x: string]: string }) => d['Category Name'] === categoryName);
        
        if (!item) {
          categoryNames.push('');
          seriesNames.push('');
          isPercentArray.push(false);
          yValues.push(0);
          xValues.push(categoryIndex);
          indexValues.push(0);
          actualIndexValues.push(null);
        } else {
          categoryNames.push(item['Category Name']);
          seriesNames.push(item['Series Name']);
          isPercentArray.push(item["isPercentage"]);
          yValues.push(
            this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : 
            (!lowSample1 ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : 
            (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : 0))
          );
          xValues.push(categoryIndex);
          indexValues.push(
            this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : 
            (!lowSample1 ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : 
            (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : 0))
          );
          actualIndexValues.push(item['ActualIndexValue']);
        }
      });

      // Create series object
      // Get color from global color map based on series name
      const extractedSeriesName = seriesName;
      let seriesColor = seriesData[0]['color'];

      const globalColorMap = this._configService.getGlobalColorMap();

      // Replace the entire color lookup block inside allSeriesNames.forEach:

const isTransposed = this.properties?.StackFormat === "On";
if (isTransposed) {
  // Transposed cluster bar: each series is a metric. Use the per-metric colour
  // already assigned to the data so the bars match the legend exactly. Fall back
  // to a metric lookup in globalColorMap only when the data colour is missing.
  if (seriesData[0]?.['color']) {
    seriesColor = seriesData[0]['color'];
  } else if (globalColorMap) {
    const matchedKey = Object.keys(globalColorMap).find(key =>
      key === seriesName ||
      key.split('|').pop()?.trim() === seriesName ||
      key.includes(seriesName)
    );
    if (matchedKey) {
      seriesColor = globalColorMap[matchedKey];
    }
  }
} else {
  // Non-transposed: seriesName = audience segment, look up directly
  if (globalColorMap) {
    const matchedKey = Object.keys(globalColorMap).find(key =>
      key === seriesName ||
      key.split('|').pop()?.trim() === seriesName ||
      key.includes(seriesName)
    );
    if (matchedKey) {
      seriesColor = globalColorMap[matchedKey];
    }
  }
}
//       if (globalColorMap) {
//   // Try exact match first, then suffix match
//   const exactKey = Object.keys(globalColorMap).find(k => k === seriesName);
//   const suffixKey = !exactKey 
//     ? Object.keys(globalColorMap).find(k => 
//         k.split('|').pop()?.trim() === seriesName
//       ) 
//     : null;
//   const matchedKey = exactKey ?? suffixKey;
//   if (matchedKey) {
//     seriesColor = globalColorMap[matchedKey];
//   }
//   // If no match found, keep seriesData[0]['color'] — don't override
// }

      // if (globalColorMap) {
      //   const matchedKey = Object.keys(globalColorMap).find(
      //     key => key.includes(extractedSeriesName)
      //   );

      //   if (matchedKey) {
      //     seriesColor = globalColorMap[matchedKey];
      //   }
      //   }
      
      this.seriesData1.push({
        name: seriesName,
        type: 'column',
        color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[seriesIndex % this.barService.patternImages.length]) : 
               this.properties.gradientBarColor ? seriesData[0]['colorLinearGradient'] : seriesColor,
        visible: true,
        zIndex: 2,

        dataLabels: {
          borderWidth: 0,
        },
        data: yValues,
        categoryNames: categoryNames,
        seriesNames: seriesNames,
        isPercentArray: isPercentArray,
        xValues: xValues,
        indexValues: indexValues,
        actualIndexValues: actualIndexValues,
        changeValue: seriesData.map((seriesItem: { [x: string]: string }) => (seriesItem["Change value vs PY"])),
        significanceValue: seriesData.map((seriesItem: { [x: string]: string }) => parseFloat(seriesItem["Significance"])),
        significanceValue2: seriesData.map((seriesItem: { [x: string]: string }) => parseFloat(seriesItem["Significance2"])),
        sampleSizeValues: seriesData.map((seriesItem: { [x: string]: string }) => parseFloat(seriesItem["Sample size"])),
        roundedValue: seriesData.map((seriesItem: { [x: string]: string }) => seriesItem["Rounded Value"]),
        tooltip: [],
        isPercentage: seriesData[0]["isPercentage"],
        Sig_LowerLimt: this.Sig_LowerLimt,
        Sig_UpperLimt: this.Sig_UpperLimt,
        Significance_Value: seriesData.map((seriesItem: { [x: string]: string }) => seriesItem["Significance_Value"]),
      });

   
    });
  // ✅ FIX: compute y-axis using STACK TOTALS (not per-series max)
// if (this.properties?.stacking) {
//   // percent stacking
//   this.min = 0;
//   this.max = 100;
// } else {
const allValues = this.seriesData1.flatMap((s: any) => (s.data || []).map((v: any) => typeof v === 'number' ? v : Number(v) || 0));
const maxVal = Math.max(...allValues, 0);
const minVal = Math.min(...allValues, 0);
this.min = minVal < 0 ? minVal * 1.1 : 0;
this.max = maxVal * 1.08;
// }

// For negative bars: verticalAlign:'bottom' places label below bar tip (in white space).
this.seriesData1.forEach((s: any) => {
  s.data = (s.data as any[]).map((v: any) =>
    typeof v === 'number' && v < 0
      ? { y: v, dataLabels: { verticalAlign: 'bottom', inside: false, y: -5 } }
      : v
  );
});

// Extract category names from all data (without adding empty string at the beginning)
this.categories = Array.from(new Set(chartData[0].data.map((item: { [x: string]: string }) => item['Category Name'])));
this.chartCategories = this.categories;

// Assign seriesData1 to seriesData so the chart can use it
this.seriesData = this.seriesData1;
 

    }
    else {
      let seriesData: any[] = [];
      let value = 0;
      let i = 0;
      let maxValue = 0;
      let minValue = 0;
      let j = -1;
      let finalValue = 0;
      //get the first series name
      const firstItem = chartData[0].data[0]['Series Name'];

      //get the category images
      this.categoryImages = chartData[0].data.map((item: { [x: string]: string }) => (item["Category Image"]));
      this.categoryImages = [''].concat(this.categoryImages);
      //extract all data matching the series name
      const indiaData = chartData[0].data.filter((item: { [x: string]: string }) => item['Series Name'] === firstItem);


      //calculate the min and max value for the y-axis
      maxValue = Math.max(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
      minValue = Math.min(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
      this.max = maxValue + Math.ceil(maxValue * 0.10);
      this.min = minValue + Math.ceil(minValue * 0.10);
      //loop throught he filtered data
      this.seriesData1 = indiaData.map((item: { [x: string]: string }) => ({

        //extract Value,if null plot as 0
        value: item['Value'] == null ? 0 : parseFloat(item['Value']),
        //if lowsample is selected,if Value extract has sampl size greater than the threshold(this.barService.sampleSizeConstant) plot as 0
        numericValue: !lowSample1 ? value : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? value : 0),
        //name for each datapoint
        name: item['Category Name'],

        //apply pattern/gradient bar color or default color based on selection
        color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? item['colorLinearGradient'] : item['color'],

        visible: true,
        zIndex: 2,
        type: 'column',
        dataLabels: {

          borderWidth: 0,

        },
       
  seriesName: item['Series Name'],
          y: !lowSample1 ? item['Value'] == null ? 0 : parseFloat(Number(item["Value"]).toFixed(this.properties.decimalRoundOff)) : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['Value'] == null ? 0 : parseFloat(Number(item["Value"]).toFixed(this.properties.decimalRoundOff)) : 0),
          //x value is used just to assign different colors for each bar
          x: parseInt(item['XValue']),
        //extract changeVs value
        changeValueSeries: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Change value vs PY"])),
        //extract significance value
        significance: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance"])),
        //extract significance2 value
        significance2: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance2"])),
        //extract sample size value
        sampleSize: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Sample size"])),
        //extract Value
        roundedValue: indiaData.map((item: { [x: string]: string }) => item["Value"]),
        //include tooltip to reflect the datalabel property selected
        tooltip: [],


      }));


      //extract category names
      this.categories = Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name'])));
      this.categories = [''].concat(Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name']))));

      // //include additional series for marker
      // indiaData.forEach((item: { [x: string]: string }, index: number) => {
      //   let markerStyle = this.properties.markerStyle;
      //   let offsetMultiplier = 0.03;
      //   // Change marker style to triangle if 'Value' is negative and marker style is 'triangle'
      //   if (parseFloat(item['Value']) < 0 && markerStyle === 'triangle') {
      //     markerStyle = 'triangle-down'; // Or whatever style you want to use for negative values
      //   }
      //   if (parseFloat(item['Value']) < 50 && parseFloat(item['Value']) > 0) {
      //     offsetMultiplier = 0.1; // Further increase offset if value is less than 50
      //   }
      //   if (parseFloat(item['Value']) <= 80 && parseFloat(item['Value']) >= 50 && parseFloat(item['Value']) > 0) {
      //     offsetMultiplier = 0.04; // Increase offset if value is less than or equal to 80 and greater than 0
      //   }
      //   this.seriesData1.push({
      //     name: item['Category Name'],
      //     type: 'scatter',
      //     zIndex: 1,
      //     marker: {
      //       symbol: markerStyle,
      //       fillColor: 'red',
      //       lineColor: 'red',
      //       lineWidth: 2,
      //     },
      //     enableMouseTracking: false,
      //     showInLegend: false,
      //     visible: this.properties.marker === 'enable',
      //     data: [{
      //       name: item['Category Name'],
      //       y: !lowSample1 ? (item['Value'] == null || parseFloat(item['Value']) === 0) ? null :
      //         parseFloat(item['Value']) > 0 ? parseFloat(item['Value']) + (offsetMultiplier * parseFloat(item['Value'])) :
      //           parseFloat(item['Value']) + (0.04 * parseFloat(item['Value'])) :
      //         (parseFloat(item['Sample size']) > this.stackService.sampleSizeConstant && item['Value'] != null && parseFloat(item['Value']) !== 0) ?
      //           parseFloat(item['Value']) > 0 ? parseFloat(item['Value']) + (0.03 * parseFloat(item['Value'])) :
      //             parseFloat(item['Value']) + (0.05 * parseFloat(item['Value'])) : null,
      //       x: index + 1,
      //       z: parseFloat(item['Sample Size']) > this.stackService.sampleSizeConstant ?
      //         0 :
      //         (item['Value'] != null ?
      //           parseFloat(item['Value']) :
      //           0),
      //     }],
      //   });
      // });
// Force Vertical Cluster Bar to allow multiple metrics



    }
console.log(this.seriesData1);
  }

  /**
   * Cleans up names by removing text before the pipe character (|)
   * e.g., "brands|Brand 01" becomes "Brand 01"
   */
  // cleanName(name: string): string {
  //   if (name && typeof name === 'string' && name.includes('|')) {
  //     const parts = name.split('|');
  //     return parts.length > 1 ? parts[parts.length - 1].trim() : parts[0].trim();
  //   }
  //   return name || '';
  // }

//   cleanName(name: string): string {
//   if (name && typeof name === 'string' && name.includes('|')) {
//     const parts = name.split('|');
    
//     // ✅ FIX: if second part contains 'yes', keep full string
//     // so "Gender|Male|Yes" stays as "Gender|Male|Yes" not "Yes"
//     if (parts[1]?.toLowerCase().includes('yes')) {
//       return name.trim();
//     }
    
//     // ✅ FIX: if 3+ parts, return last 2 joined
//     // so "Gender|Male|Yes" → "Male|Yes" as fallback
//     if (parts.length > 2) {
//       return parts.slice(-2).join('|').trim();
//     }
    
//     // Original behavior for simple "Brand|Name" → "Name"
//     return parts.length > 1 ? parts[parts.length - 1].trim() : parts[0].trim();
//   }
//   return name || '';
// }

cleanName(name: string): string {
  if (name && typeof name === 'string' && name.includes('|')) {
    const parts = name.split('|');
    
    // "Gender|Male|Yes" → drop last "|Yes" part → return "Gender|Male"
    if (parts[parts.length - 1]?.toLowerCase().trim() === 'yes') {
      return parts.slice(0, -1).join('|').trim();
      // parts = ["Gender", "Male", "Yes"]
      // slice(0, -1) = ["Gender", "Male"]
      // join = "Gender|Male"  ✅
    }
    
    // "Age Group|18-24" → return "18-24" (original behavior)
    return parts.length > 1 ? parts[parts.length - 1].trim() : parts[0].trim();
  }
  return name || '';
}

 preparemainChartData(data: any) {
    let i = 0;
    this.chartMainData = [];

    data.metric_value.forEach((lev2: any) => {
      const hasPercentageExtension =
        lev2.extensionOptions?.some(
          (e: any) =>
            e.id === 'percentageSymbol' &&
            e.selected
        ) || false;
      lev2.data.forEach((dataArr: any) => {
    // The audience column split: "Audience|Gender|Male" → "Male"
    const rawColChild: string = (dataArr.colChild || '').replace(/\|[Yy]es$/i, '').trim();
    const colChildParts = rawColChild.split('|');
    const seriesName = colChildParts[colChildParts.length - 1].trim(); 
    const isTransposed = this.properties?.StackFormat === "On";
    const rawRowChild: string = (dataArr.rowChild || '')
  .replace(/\s*\|\s*/g, '|')      
  .replace(/\|[Yy]es$/i, '')     
  .trim();

const rawOption: string = (lev2.option ?? lev2.metricName ?? '')
  .replace(/\s*\|\s*/g, '|')
  .replace(/\|[Yy]es$/i, '')
  .trim();
      const metricLabel = rawOption !== '' ? rawOption : rawRowChild;
      const categoryName = isTransposed ? seriesName : metricLabel;
      const seriesNameFinal = isTransposed ? metricLabel : seriesName;


        let d1 = {
          // "Series Name": this.properties.StackFormat=="On"? this._configService.selectedSnapshotType.toLowerCase().includes("multi") ? cleanedColChild : cleanedColChild : cleanedOption,
          // "Category Name": this.properties.StackFormat=="On"? cleanedOption : this._configService.selectedSnapshotType.toLowerCase().includes("multi") ? cleanedColChild : cleanedColChild,


          // "Series Name":cleanedColChild,
          // "Category Name":cleanedOption,

          // "Series Name":  isTransposed ? cleanedOption   : cleanedColChild,
          // "Category Name": isTransposed ? cleanedColChild : cleanedOption,
         "Series Name": seriesNameFinal,   
         "Category Name": categoryName, 

          "Rounded Value": dataArr.data == null ? null : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          "ValueForIndex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
          "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
          "Label": dataArr.data == null ? "NA" : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          "Change value vs PY": dataArr.changeVsPY==null?"NA":dataArr.changeVsPY,
          "Significance": "-1",
          "Sample size": dataArr.baseValueforLSorIs,
          "Significance2": "1",
          "XValue": ++i,
           "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
          //  "isPercentage":
          //   hasPercentageExtension
          //     ? false
          //     : true,
          "Sig_LowerLimt": this.Sig_LowerLimt,
          "Sig_UpperLimt": this.Sig_UpperLimt,
          "Significance_Value": dataArr.Significance_Value,
          "color": dataArr.color,
          "colorLinearGradient": dataArr.colorLinearGradient
        }
        this.chartMainData.push(d1);
        if (!isNaN(d1["Rounded Value"])) {
          const rounded = Math.round(parseFloat(d1["Rounded Value"]) * 10) / 10;
          if (this.maxBarValue < rounded) {
            this.maxBarValue = rounded;
          }
        }
      });
    });
    if (this.configuredProperties) {
      if (this.configuredProperties?.sort == "ascending") {
        const sortedData = this.chartMainData.sort((a: any, b: any) => {
          // Compare the "Value" field in ascending order
          if (a["Value"] === "NA" && b["Value"] === "NA") {
            return 0; // If both are "NA", keep them in the same order
          }
          if (a["Value"] === "NA") {
            return 1; // If a is "NA", place it after b
          }
          if (b["Value"] === "NA") {
            return -1; // If b is "NA", place it after a
          }

          // Otherwise, compare numerically (assuming "Value" is a number or can be coerced into a number)
          return a["Value"] - b["Value"];
        });
        this.chartMainData = sortedData;
      }
      if (this.configuredProperties?.sort == "descending") {
        const sortedDataDesc = this.chartMainData.sort((a: any, b: any) => {
          // Compare the "Value" field in descending order
          if (a["Value"] === "NA" && b["Value"] === "NA") {
            return 0; // If both are "NA", keep them in the same order
          }
          if (a["Value"] === "NA") {
            return -1; // If a is "NA", place it after b
          }
          if (b["Value"] === "NA") {
            return 1; // If b is "NA", place it after a
          }

          // Otherwise, compare numerically (assuming "Value" is a number or can be coerced into a number)
          return b["Value"] - a["Value"]; // For descending order, reverse the comparison
        });
        this.chartMainData = sortedDataDesc;
      }
    }

    // this.chartMainData=this.chartMainData.slice(0,1);
  }
  seriesObject: any = {};
  accessSeriesValues(islowSample: any) {
    const seriesObjects: any = {};
    const categories: string[] = [];
    const categoryImages: any[] = [];
    for (const series of this.StackChartData) {
      const seriesName = this.ChartProperties.StackFormat=="On"?series["Category Name"]:series["Series Name"]; //Access series name
      const roundedValue = series["Rounded Value"];
      let numericValue = (roundedValue === " " || roundedValue === null) ? 0 : Number(parseFloat(series["Value"]).toFixed(this.properties.decimalRoundOff));
      let label = (series.Label); //If any customised label to be used can be accessed from this property
      const change = parseFloat(series["Change value vs PY"]); //Change value compared to previous year
      const significance = parseFloat(series["Significance"]);
      const category =this.ChartProperties.StackFormat=="On"? series["Series Name"]:series["Category Name"]; //Access category names
      const sampleSize = series["Sample size"];
      const significance2 = series["Significance2"];
      const categoryImage = series["Category Image"];
     
      if(true){
      // Check if chartProperties.showNegative is false and series has negative values
      if (!this.properties.showNegative && numericValue < 0) {
        continue; // Skip this series
      }

      let finalvalue = !islowSample ? numericValue : (parseFloat(series['Sample size']) > this.barService.sampleSizeConstant ? numericValue : 0);
      //let pointWidth = category.length < 5 ? 70 : 45; //If categories are more than 5 then set pointwidth to 70
      let pointWidth = category.length < 5 ? 90 : 60; 
      let tooltip = "";
     if(this.properties.stackPosition=="BrandsinX"){
      if (!seriesObjects[seriesName]) {
        seriesObjects[seriesName] = {
          name: seriesName,
          data: [],
          label: [],
          roundedValue: [],
          changeValue: [],
          significanceValue: [],
          significanceValue2: [],
          sampleSizeValues: [],
          visible: true,
          pointWidth: pointWidth,
          tooltip: []
        };
      }
      seriesObjects[seriesName].data.push(finalvalue);
      seriesObjects[seriesName].roundedValue.push(roundedValue);
      seriesObjects[seriesName].label.push(label);
      seriesObjects[seriesName].changeValue.push(change);
      seriesObjects[seriesName].significanceValue.push(significance);
      seriesObjects[seriesName].significanceValue2.push(significance2);
      seriesObjects[seriesName].sampleSizeValues.push(sampleSize);
      seriesObjects[seriesName].tooltip.push(tooltip);
      if (!categories.includes(category)) {
        categories.push(category);
      }
     }
     else{
      if (!seriesObjects[category]) {
        seriesObjects[category] = {
          name: category,
          data: [],
          label: [],
          roundedValue: [],
          changeValue: [],
          significanceValue: [],
          significanceValue2: [],
          sampleSizeValues: [],
          visible: true,
          pointWidth: pointWidth,
          tooltip: []
        };
      }
      seriesObjects[category].data.push(finalvalue);
      seriesObjects[category].roundedValue.push(roundedValue);
      seriesObjects[category].label.push(label);
      seriesObjects[category].changeValue.push(change);
      seriesObjects[category].significanceValue.push(significance);
      seriesObjects[category].significanceValue2.push(significance2);
      seriesObjects[category].sampleSizeValues.push(sampleSize);
      seriesObjects[category].tooltip.push(tooltip);

      if (!categories.includes(seriesName)) {
        categories.push(seriesName);
      }
      console.log(categories);
     }

     
      // if (this.categoryImages) {
      //   categoryImages.push(categoryImage);
      // }
    }
    this.seriesData = Object.values(seriesObjects).map((item: any) => {
      return {
        name: item.name,
        data: item.data,
        label: item.label,
        color: item.color,
        changeValue: item.changeValue,
        roundedValue: item.roundedValue,
        visible: item.visible,
        significanceValue: item.significanceValue,
        significanceValue2: item.significanceValue2,
        sampleSizeValues: item.sampleSizeValues,
        showInlegend: item.showInLegend,
        tooltip: item.tooltip
      };
    }
    );

    this.seriesData.reverse(); // Reverse seriesData to get the first series below and then stack the rest
    this.chartCategories = categories;
    this.categoryImages = categoryImages;
  }
  }

 
  customization(): Observable<any> {
      const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience') 
      ? this._configService.audienceCohortType 
      : 'NA';
     return _.cloneDeep(this._customSnapshotService.getChartCustomization("Vertical Cluster Bar", snapshotTypeSelectedName, cohortType));
  }
  renderChart2(container2: any, data:any,properties: any) {
    localStorage.setItem("properties", JSON.stringify(properties));
    this.ChartProperties = properties;
   
    
    if(this.isOutput){
      const containerEl = document.getElementById(container2);
const containerWidth = containerEl ? containerEl.offsetWidth : 400;

const numSeries = this.seriesData1.length;
const numCategories = this.chartCategories.length;

const BAR_WIDTH = 45;        // fixed px per bar
const BAR_GAP = 4;           // fixed px gap between bars in same cluster  
const GROUP_GAP = 20;        // fixed px gap between clusters
// Convert BAR_GAP to pointPadding (relative to pointWidth)
const pointPaddingValue = BAR_GAP / (2 * BAR_WIDTH);  // Highcharts uses half-gap on each side

// Convert GROUP_GAP to groupPadding (relative to total group slot width)  
const groupSlotWidth = numSeries * (BAR_WIDTH + BAR_GAP);
const groupPaddingValue = GROUP_GAP / (2 * groupSlotWidth);

// Total width needed for all bars
const totalBarsWidth = numCategories * (numSeries * (BAR_WIDTH + BAR_GAP) + GROUP_GAP);
const plotWidth = Math.max(containerWidth - 80, totalBarsWidth); // 80 = margins

// How many categories fit in container without scroll
// const categorySlotWidth = numSeries * (BAR_WIDTH + BAR_GAP) + GROUP_GAP;
// const visibleCategories = Math.floor((containerWidth - 80) / categorySlotWidth);
// const maxCategoriesToShow = Math.max(1, visibleCategories);
const categorySlotWidth = numSeries * (BAR_WIDTH + BAR_GAP) + GROUP_GAP;
const visibleCategories = Math.floor((containerWidth - 80) / categorySlotWidth);
const maxCategoriesToShow = Math.max(1, visibleCategories);

const enableCategoryScroll = numCategories > maxCategoriesToShow;
const xAxisMax = enableCategoryScroll
  ? maxCategoriesToShow - 1
  : numCategories - 1;
      const seriesDataForFormatter = data;
      const categoriesForFormatter = this.categories;
      const categoryImagesForFormatter = this.categoryImages;
      const serviceBar = this.barService;
      //const maxCategoriesToShow = 3;
      const sampleSizeConstant = this.barService.sampleSizeConstant;
      const configService = this._configService;
      let yAxisMaxValue = this.max;
      let yAxisMinValue = this.min;
      //let tickInterval = Math.ceil(this.max / 10);
      let tickInterval = Math.ceil((this.max * 1.05) / 10);
      let plotBandsConfig: { color: string; from: number; to: number; }[] = [];
       let popUp = this.popUp;
       //const containerEl = document.getElementById(container2);
//const containerWidth = containerEl ? containerEl.offsetWidth : 400;
const barSlotWidth = 30 + 10; // pointWidth + gap per bar
//const numSeries = this.seriesData1.length;
const groupWidth = (numSeries * barSlotWidth) + 20; // 20px gap between groups
//const maxCategoriesToShow = Math.max(1, Math.floor(containerWidth / groupWidth));
//const enableCategoryScroll = this.chartCategories.length > maxCategoriesToShow;
// const xAxisMax = enableCategoryScroll
//   ? maxCategoriesToShow - 1
//   : this.chartCategories.length - 1;

      //const enableCategoryScroll = !popUp && this.chartCategories.length > maxCategoriesToShow;
      // const enableCategoryScroll = this.chartCategories.length > maxCategoriesToShow;
      // const xAxisMax = enableCategoryScroll
      //   ? maxCategoriesToShow - 1
      //   : this.chartCategories.length - 1;
   
      
      // To display plotbands
      const numPlotBands = this.chartCategories.length;
      if (this.ChartProperties.plotBands) {
        for (let i = 0; i < numPlotBands; i += 2) {
          const from = i + 0.5;
          const to = from + 1;
          plotBandsConfig.push({ color: this.ChartProperties.darkTheme ? this.barService.plotBandsdark : this.barService.plotBandsColor, from, to });
        }
      }

      this.chart = Highcharts.chart(container2, {
      chart: {      
          marginLeft: 60,
          marginRight: 20,
          marginTop: 30,  
         spacingLeft: 0,    
         spacingRight: 0,
        //spacing: [10, 10, 10, 10], 
        spacing: [5, 10, 10, 10],
        type: 'column',
        marginBottom: popUp ? 100 : 40,
         scrollablePlotArea: enableCategoryScroll ? {
           minWidth: totalBarsWidth + 80,
           scrollPositionX: 0,
           opacity: 0 
         } : undefined,
        backgroundColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
        style: {
          fontFamily: this.barService.textfont,
          zIndex: 1,
          overflow: 'visible',
          color: this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor,
        }
      },
      exporting: {
        enabled: false
      },
       legend: {
         enabled: !!this.popUp
        },
      title: {
        text:'',
        align: this.ChartProperties.chartTitlePosition,
        style: {
          color: this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor,
          marginleft: '4%',
          fontFamily: this.barService.textfont,
          fontSize: '2em'
        }
      },

      accessibility: {
        point: {
          valueDescriptionFormat: '{index}. {point.name}, fat: {point.x}g, sugar: {point.y}g, {point.change}g.'
        }
      },
      xAxis: {
        // reversed: true,
        // visible: true,
        // lineWidth: 1,
        // min: 0,
        // max: xAxisMax,
  gridLineWidth: this.ChartProperties.xaxisgridlines ? 1 : 0,
          tickmarkPlacement: 'between', 
  minPadding: 0,              
  maxPadding: 0, 
   y: 5,

        type: 'category',        
        startOnTick: false,      
        endOnTick: false,        
        visible: true,
        lineWidth: 1,
        min: 0,
        max: this.chartCategories.length - 1,
        categories: this.chartCategories,
        labels: {
          y:25,
          enabled: true,
          rotation: this.barService.xAxisLabelOrientation(this.ChartProperties.axisLabelOrientation, this.ChartProperties),
          useHTML: true,
          style: {
            fontFamily: this.barService.textfont,
            color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
            whiteSpace: 'nowrap',
            fontSize: popUp ? '0.7rem' : '12px',
          },
          formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
            const raw = String(this.value ?? '');
            const esc = (s: string) => s
              .replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/\"/g, '&quot;')
              .replace(/'/g, '&#39;');

            if (popUp) {
              const chart = this.axis.chart;
              const categories = (this.axis.categories || []) as any[];
              const chartWidth = chart.plotWidth || 400;
              const numCategories = Math.max(categories.length, 1);
              const baseWidth = Math.floor(chartWidth / numCategories);
              const padding = 12;
              const minWidth = 120;
              const labelWidth = Math.max(baseWidth - padding, minWidth);
              const popupLabelWidth = Math.max(categorySlotWidth - 8, labelWidth);
              return `<div title="${esc(raw)}" style="width:${popupLabelWidth}px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; line-height:1.2; text-align:center; margin:0 auto;">${esc(raw)}</div>`;
            }
            const labelWidth = Math.max(categorySlotWidth - 8, 40);
            return `<div title="${esc(raw)}" style="width:${labelWidth}px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; text-align:center; margin:0 auto;">${esc(raw)}</div>`;
          },
    // formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
    //   // Calculate available width per label
    //   const chart = this.axis.chart;
    //   const categories = this.axis.categories || [];
    //   const chartWidth = chart.plotWidth || 400;
    //   const numCategories = Math.max(categories.length - 1, 1); // Exclude first empty category
      
    //   // Calculate base width per category with enhanced popup support
    //   const baseWidth = Math.floor(chartWidth / numCategories);
    //   const padding = popUp ? 15 : 8; // Reduced padding for popup to utilize more space
    //   const minWidth = popUp ? 120 : 80; // Higher minimum width for popups
    //   const labelWidth = Math.max(baseWidth - padding, minWidth);
  
    //   // Split label into max 2 lines, not breaking words
    //   function splitLabelToTwoLines(str: string, maxWidth: number) {
    //     // Estimate average character width (in px) - adjusted for better accuracy
    //     const avgCharWidth = popUp ? 6.0 : 6.5; // Slightly smaller char width for popup to fit more text
    //     const maxCharsPerLine = Math.floor(maxWidth / avgCharWidth);
  
    //     const words = str.split(' ');
    //     let line1 = '';
    //     let line2 = '';
    //     let currentLine = '';
    //     let breakIndex = 0;
  
    //     // Build first line
    //     for (let i = 0; i < words.length; i++) {
    //       const testLine = currentLine ? currentLine + ' ' + words[i] : words[i];
    //       if (testLine.length <= maxCharsPerLine || !currentLine) {
    //         currentLine = testLine;
    //         breakIndex = i + 1;
    //       } else {
    //         break;
    //       }
    //     }
    //     line1 = currentLine;
  
    //     // Build second line with remaining words
    //     const remainingWords = words.slice(breakIndex);
    //     line2 = remainingWords.join(' ');
  
    //     // Truncate second line with ellipsis if needed
    //     if (line2.length > maxCharsPerLine) {
    //       line2 = line2.substring(0, maxCharsPerLine - 3).trim() + '...';
    //     }
  
    //     return line2 ? `${line1}<br/>${line2}` : line1;
    //   }
  
    //   let labelContent = String(this.value);
    //   labelContent = splitLabelToTwoLines(labelContent, labelWidth);
  
    //   // Determine text alignment based on number of lines
    //   const isMultiLine = labelContent.includes('<br/>');
    //   const textAlign = 'center';
  
    //   // If axisImage is enabled, show image instead
    //   if (properties.axisImage) {
    //     const categoryName = seriesDataForFormatter.find((s: any) => s.data.some((d: any) => d.name === this.value))?.data.find((d: any) => d.name === this.value)?.name;
    //           var index = categoriesForFormatter.indexOf(categoryName || String(this.value));
              
    //  if (index >= 0 && categoryImagesForFormatter[index]) {
    //   var category1 = serviceBar.baseImgPath + categoryImagesForFormatter[index] + '.png';
    //       return `<span style="display: inline-block; width: 2em; height: 2em; background: url(${category1}) no-repeat center center; background-size: cover;"></span>`;
    //     } else {
    //       return '<span>No Image</span>';
    //     }
    //   } else {
    //     // Center-align text for single line, left-align for multiple lines
    //     const marginStyle = popUp ? 'margin: 0 2px' : 'margin: 0 auto';
    //     return `<div style="width:${labelWidth}px; text-align: ${textAlign}; ${marginStyle}; padding: 0;" title="${String(this.value)}">${labelContent}</div>`;
    //   }
    // },
       
        },
        scrollbar: {
          enabled: false, // replaced by chart.scrollablePlotArea to keep bars constant
          height: 6, // Adjust the height of the scrollbar as needed
           barBackgroundColor: '#7f7f7f',//#802AB7,
          barBorderRadius: 5,
          barBorderWidth: 0,
          barBorderColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
          buttonBackgroundColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
          buttonBorderWidth: 0,
          buttonArrowColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
          buttonBorderRadius: 5,
          rifleColor: 'none',
          trackBackgroundColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
          trackBorderWidth: 0,
          trackBorderColor: 'black',
          trackBorderRadius: 5,
          
        },
        tickLength: 5,
         tickInterval: 1, 
        plotBands: plotBandsConfig,
      },    
      yAxis: {
        gridLineWidth: this.ChartProperties.yaxisgridlines ? 1 : 0,
        lineWidth: 0,
   min: this.min,
  max: this.max * 1.05,
        endOnTick: false, 
        startOnTick: false,
        plotLines: [{
          value: 0,
          width: 1,
          color: this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : '#aaa',
          zIndex: 5,
        }],
        labels: {
          enabled: false,
          style: {
            color: this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor,
          },
        },
        tickInterval:tickInterval,
        title: {
          text: '',
          fontFamily: this.barService.textfont
        },
        stackLabels: {
          enabled: false,
        },
      },
      credits: {
        enabled: false
      },

      tooltip: {
        enabled: true,
        borderWidth: 1,
        useHTML: true,
       backgroundColor:  'white',
        shadow: false,
       outside: true,
        style: {
           zIndex: 9999,
           backgroundColor: 'white',
          pointerEvents: 'none' 
        },

        formatter: function () {
             if (this.series.name === 'Marker1') return false;
          let isDefaultTooltip = properties.toolTipStyle;
          const dotColor = this.color
          const backgroundcolor = '#f5f5f5';
          const backgroundcolor2 = properties.darkTheme ? 'white' : '#ddddd';
          const text = properties.showDataLabel ? this.series.userOptions.tooltip[this.point.x] : this.y;
 const content =
               `<div style="background: transparent; border: none; border-radius: 8px; min-width: 20px; font-size: 0.8em; display: flex; align-items: center; ">
            <span style="display:inline-block; width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
            <span>${this.point.series.name}: </span>
            <b style="margin-left:4px;">${text}</b>
          </div>`;
 
  return content;
//         if (isDefaultTooltip != 'default') {
//           const content =
//                `<div style="background: transparent; border: none; border-radius: 8px; min-width: 20px; font-size: 0.8em; display: flex; align-items: center; ">
//             <span style="display:inline-block; width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
//             <span>${this.point.series.name}: </span>
//             <b style="margin-left:4px;">${text}</b>
//           </div>`;
 
//   return content;

          
//           }
//       else {
//     const commonContent =
//               `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 999; padding: 2%; border-radius: 5px; margin: 0; background-color :${backgroundcolor2};">` +
             
//               `<span><strong>Category Name:</strong></span> ${this.point.series.name}<br>` +
//               `<span><strong>Value:</strong></span> ${text}`;



//             return commonContent + '</div>';
// }
        },
      } as any,    
      plotOptions: {
        series: {
          animation: false,
        },
        column: {
                    pointWidth: BAR_WIDTH,  
                    pointPadding: pointPaddingValue,  
                    groupPadding: groupPaddingValue, 
          stacking: undefined,
          shadow: this.ChartProperties.shadow ? {
            color: 'rgba(0, 0, 0, 0.5)',
            offsetX: 1,
            offsetY: 1,
            opacity: 0.5,
            width: 6,
          } : false,
          dataLabels:
          {
            allowOverlap: true,

            enabled: this.ChartProperties.showDataLabel,
            color: this.ChartProperties.dataLabelColor == "default" ? (this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor) : this.ChartProperties.dataLabelColor,
            verticalAlign: 'top',
            inside: false,
            align: 'center',
            x: 0,
            y: -5,
            useHTML: true,
            crop: false,            
            overflow: 'allow',       
            style: {
              backgroundColor: 'transparent',
              shadow: false,
              borderWidth: 0,
              textOutline: 'none',
              borderRadius: 0,
              fontSize: this.ChartProperties.dataLabelSize,
              fontFamily: this.barService.textfont,
              fontWeight: "normal",
              whiteSpace: 'normal'
            },
            formatter: function (this: any) {
                if (properties.datalabelStyle == "index") {
                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (this.series.userOptions.isPercentage ? '%' : '') : serviceBar.nullValueText;

                  text = configService.CheckLSorIScondition(configService.userRole, text, this.series.userOptions.sampleSizeValues[this.point.x],);

                  this.series.userOptions.tooltip[this.point.x] = text;
                  let text2 = this.series.userOptions.actualIndexValues[this.point.x] == null
                    ? serviceBar.nullValueText
                    : this.series.userOptions.roundedValue[this.point.x] == -1 ? -1 : this.series.userOptions.roundedValue[this.point.x] != null ? Math.round(this.series.userOptions.actualIndexValues[this.point.x]) : serviceBar.nullValueText;

                  if (text2 == "-1" || text2 == -1) {
                    text2 = "NA";
                  }
                  text2 = configService.CheckLSorIScondition(configService.userRole, text2, this.series.userOptions.sampleSizeValues[this.point.x],);
                  let color = configService.CheckIndexColoring(text2);

                  this.series.userOptions.tooltip[this.point.x] = text + "(" + text2 + ")";;
                  return (
                    '<div style="text-align:center; line-height:1.3;"><div style="font-size:' + properties.dataLabelSize + ';">' + text + '</div>' +
                    '<div style="color:' + color + ';font-size:' + (parseFloat(properties.dataLabelSize) - 0.2) + 'rem;">(' + text2 + ')</div></div>'
                  );
                }

                if (properties.datalabelStyle == "sigChange") {
                  //extract each changeVs value
                  let changeText = this.series.userOptions.isPercentage ? (this.series.userOptions.changeValue[this.point.x]) * 100 :
                    this.series.userOptions.changeValue[this.point.x];
                  //if roundedvalue extracted is null show NA, else if % option from datalabel format is selected then add % to the datalabel text
                  let textCheck = configService.CheckLSorIScondition(configService.userRole, this.y, this.series.userOptions.sampleSizeValues[this.point.x]);
                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? textCheck + (this.series.userOptions.isPercentage && (textCheck != 'I/S') ? '%' : '') : serviceBar.nullValueText;

                  // text = textCheck+ (this.series.userOptions.isPercentage && (textCheck != 'I/S') ? '%' : '');
                  //extarct each signififcance value
                  let sig = this.series.userOptions.significanceValue[this.point.x];
                  //set the significance arrow according to its value
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  //assign color to the arrow
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  //include + if changeValue is positive
                  // if (parseFloat(changeText) > 0) {
                  //   changeText = "+" + changeText;
                  // }
                  let sigClass = this.series.userOptions.Significance_Value[this.point.x] < this.series.userOptions.Sig_LowerLimt ? 'red' : this.series.userOptions.Significance_Value[this.point.x] > this.series.userOptions.Sig_UpperLimt ? 'green' : 'black';
                  
                  //merge text+changeText+significance
                  let finalText: string;
                  let tooltipText: string;
                  
                  if (this.series.userOptions.changeValue[this.point.x] == null || this.series.userOptions.changeValue[this.point.x] == 'NA') {
                    finalText = '<div style="text-align:center; line-height:1.3;">' +
                      '<div style="font-size:' + properties.dataLabelSize + ';">' + text + '</div>' +
                      (this.series.userOptions.roundedValue[this.point.x] != null && textCheck != 'I/S' ?
                        '<div style="color:black; font-size:' + properties.dataLabelSize + ';">(NA)</div>' : '') +
                      '</div>';

                    tooltipText = '<span>' +
                      '<span style="font-size:' + properties.dataLabelSize + ';">' + text + '</span>' +
                      (this.series.userOptions.roundedValue[this.point.x] != null && textCheck != 'I/S' ? '<span>&nbsp;' +
                        '<span style="color:black; font-size:' + properties.dataLabelSize + ';">(NA)</span>' +
                        '</span>' : '') +
                      '</span>';
                  }
                  else {
                    finalText = '<div style="text-align:center; line-height:1.3;">' +
                      '<div style="font-size:' + properties.dataLabelSize + ';">' + text + '</div>' +

                      (this.series.userOptions.Significance_Value[this.point.x] == 0 ?
                        '<div style="color:' + sigClass + '; font-size:' + properties.dataLabelSize + ';">(' + (this.series.userOptions.Significance_Value[this.point.x] + (this.series.userOptions.isPercentage ? '%' : '')) + ')</div>'
                        :
                      (this.series.userOptions.roundedValue[this.point.x] != null && changeText != null && textCheck != 'I/S' ?
                        '<div style="color:' + sigClass + '; font-size:' + properties.dataLabelSize + ';">(' + (parseFloat(Number(changeText).toFixed(1)) + (this.series.userOptions.isPercentage ? '%' : '')) + ')</div>' : '')) +
                      '</div>' ;

                    tooltipText = '<span>' +
                      '<span style="font-size:' + properties.dataLabelSize + ';">' + text + '</span>' +

                      (this.series.userOptions.Significance_Value[this.point.x] == 0 ?
                        '<span style="color:' + sigClass + '; font-size:' + properties.dataLabelSize + ';margin-left:3px;  ">(' + (0 + (this.series.userOptions.isPercentage ? '%' : '')) + ')</span>&nbsp;' +
                        '</span>'
                        :
                      (this.series.userOptions.roundedValue[this.point.x] != null && changeText && textCheck != 'I/S' ? '<span>&nbsp' +
                        '<span style="color:' + sigClass + '; font-size:' + properties.dataLabelSize + ';margin-left:3px;  ">(' + (parseFloat(Number(changeText).toFixed(1)) + (this.series.userOptions.isPercentage ? '%' : '')) + ')</span>&nbsp;' +
                        '</span>' : '')) +
                      '</span>';
                  }
                  
                  //assign tooltip - this will always be set now even if label is hidden
                  this.series.userOptions.tooltip[this.point.x] = tooltipText;
                  
                  // Hide labels < 10 in normal view, also hide NA (but tooltip is already set)
                  // if (!popUp && (parseFloat(this.y) < 10 || text === serviceBar.nullValueText || String(text).includes('NA'))) {
                  //   return '';
                  // }
                  
                  //return the finalText
                  return finalText;
                }

                //significance and changeVs option is selected from datalabel property
                if (properties.datalabelStyle == "significance + changeVs") {
                  //if roundedvalue extracted is null show NA, else if % option from datalabel format is selected then add % to the datalabel text
                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  //extract each changeVs value
                  let changeText = this.series.userOptions.changeValueSeries[this.point.x];
                  //extarct each signififcance value
                  let sig = this.series.userOptions.significanceValue[this.point.x];
                  //set the significance arrow according to its value
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  //assign color to the arrow
                  let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                  //include + if changeValue is positive
                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  //merge text+changeText+significance
                  let finalText = '<span>' +
                    '<span>' + text + '</span>' +
                    (this.series.userOptions.roundedValue[this.point.x] != null && changeText ? '<span>&nbsp' +
                      '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
                      '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
                    '</span>';
                  //assign the finalText to tooltip
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  //return the finalText
                  return (
                    finalText
                  );


                }
                if (properties.datalabelStyle == "change") {

                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  let changeText = this.series.userOptions.changeValueSeries[this.point.x];
                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  let finalText = '<span>' + text + "  " +
                    (this.series.userOptions.roundedValue[this.point.x] != null && changeText ? '<span>&nbsp' +
                      '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
                      '</span>' : '');
                  this.series.userOptions.tooltip[this.point.x] = finalText;

                  return (
                    finalText
                  );

                }

                if (properties.datalabelStyle == "ls") {


                  let text = parseFloat(this.series.userOptions.sampleSizeValues[this.point.x]) > serviceBar.sampleSizeConstant ? this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText : serviceBar.lowSampleText;
                  let finalText = '<b style="font-size:' + properties.dataLabelSize + ';">' +
                    text +
                    '</b> ' +
                    '<span style="opacity: 0.5"></span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;

                  // Hide labels < 10 in normal view, also hide NA
                  // if (!popUp && (parseFloat(this.y) < 10 || text === serviceBar.nullValueText || text.includes('NA'))) {
                  //   return '';
                  // }

                  return finalText;
                }
                if (properties.datalabelStyle == "significance") {
                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  let sig = this.series.userOptions.significance[this.point.x];
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                  let finalText = '<span style="font-size:' + properties.dataLabelSize + ';">' + text + (this.series.userOptions.roundedValue[this.point.x] != null ? '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span>' : '') + '</span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  
                  // Hide labels < 10 in normal view, also hide NA
                  // if (!popUp && (parseFloat(this.y) < 10 || text === serviceBar.nullValueText || text.includes('NA'))) {
                  //   return '';
                  // }
                  
                  return (
                    finalText
                  )

                }
                if (properties.datalabelStyle == "default") {

                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (this.series.userOptions.isPercentage? '%' : '') : serviceBar.nullValueText;

                  text = configService.CheckLSorIScondition(configService.userRole, text, this.series.userOptions.sampleSizeValues[this.point.x],);

                  this.series.userOptions.tooltip[this.point.x] = text;

                  // Hide labels < 10 in normal view, also hide NA
                  // if (!popUp && (parseFloat(this.y) < 10 || text === serviceBar.nullValueText || text.includes('NA'))) {
                  //   return '';
                  // }

                  return (
                    '<span style="font-size:' + properties.dataLabelSize + ';">' + text + '</span>'
                  );
                }
                if (properties.datalabelStyle == "datalabel") {

                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (this.series.userOptions.isPercentage ? '%' : '') : serviceBar.nullValueText;
                  this.series.userOptions.tooltip[this.point.x] = text;
                  
                  // Hide labels < 10 in normal view, also hide NA
                  // if (!popUp && (parseFloat(this.y) < 10 || text === serviceBar.nullValueText || text.includes('NA'))) {
                  //   return '';
                  // }
                  
                  return (
                    '<span style="font-size:' + properties.dataLabelSize + ';">' + text + '</span>'
                  );
                }

                if (properties.datalabelStyle == "significance2") {
                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  let changeText = this.series.userOptions.changeValueSeries[this.point.x];
                  let sig = this.series.userOptions.significance[this.point.x];
                  let sig1 = this.series.userOptions.significance2[this.point.x];
                  let sColor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  let changeColor = sig1 < 0 ? serviceBar.lowSignificance : (sig1 > 0 ? serviceBar.highSignificance : properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor);


                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  let finalText = '<span>' + text +
                    (this.series.userOptions.roundedValue[this.point.x] != null && changeText ? '&nbsp<span style="color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + ' "> ' +
                      '<span style="font-size:' + serviceBar.changeValueFontSize + '; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                      '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return (
                    finalText
                  );
                }


                return !Number.isNaN(this.series.userOptions.roundedValue[this.point.x]) ? this.y : 'NA';

              },
          }
        },
      },
      series: this.seriesData1
    } as any);
   // REPLACE the renderer block with this:
const chartRef = this.chart;
// const seriesNames = this.seriesData1.map((s: any) => s.name);
// const labelColor = this.ChartProperties.darkTheme 
//   ? this.barService.darkThemeTextColor 
//   : this.barService.lightThemeTextColor;

// setTimeout(() => {
//   const baseY = chartRef.plotTop + chartRef.plotHeight + 15;

//   chartRef.series.forEach((series: any, seriesIndex: number) => {
//     series.points.forEach((point: any) => {
//       // center of THIS individual bar (includes the cluster offset)
//       const shape = point.shapeArgs || {};
//       const barCenterX = chartRef.plotLeft + (shape.x || 0) + (shape.width || 0) / 2;

//       chartRef.renderer.text(
//         seriesNames[seriesIndex] || '',
//         barCenterX,
//         baseY                       // same Y for all → single horizontal row
//       )
//       .attr({ align: 'center', zIndex: 5 })
//       .css({
//         color: labelColor,
//         fontSize: '10px',
//         whiteSpace: 'nowrap'
//       })
//       .add();
//     });
//   });
// }, 0);
        }
        else{
        

  // Ensure container exists
  const container = document.getElementById(container2);
  if (!container) {
    console.error('Chart container not found:', container2);
    return;
  }
   if (this.chart) {
    this.chart.destroy();
    this.chart = null;
  }
container.innerHTML = '';
  // Ensure container exists
 
this.ChartProperties = properties;
   this.accessSeriesValues(this.properties.datalabelStyle == 'lowSample');

   let previewMax = Number.MIN_VALUE;
let previewMin = Number.MAX_VALUE;
for (const seriesName in this.seriesData) {
  const s = (this.seriesData as any)[seriesName];
}
// simpler — just derive from seriesData array directly
const allPreviewValues = this.seriesData.flatMap((s: any) => s.data || []).filter((v: any) => typeof v === 'number');
previewMax = Math.max(...allPreviewValues, 0);
previewMin = Math.min(...allPreviewValues, 0);
const previewYMax = previewMax + Math.ceil(previewMax * 0.10);
const previewYMin = previewMin >= 0 ? 0 : previewMin + Math.ceil(previewMin * 0.10);

    let yAxisMaxValue = 0;
    let yAxisMinValue = 0;
    let maxDataValue = 0;
    let serviceBar = this.barService;
    let sampleSizeConstant = this.barService.sampleSizeConstant;
    const maxCategoriesToShow = 5; //number of categories to display
    const numberOfTicks = 10; // number of axis division
    const sumArray = new Array<number>();
    const minArray = Array.from({ length: this.seriesData[0].data.length }, () => Number.MAX_SAFE_INTEGER);
    const updatedCategories = this.barService.updatedCategories;
    let plotBandsConfig: { color: string; from: number; to: number; }[] = [];
    const numPlotBands = this.chartCategories.length;
    const defaultCategories = this.chartCategories;
    let categoryImages = this.categoryImages;
    const numberOfSeries = Math.min(this.seriesData.length, this.barService.customColors.length);
    const reversedColors = this.barService.customColors.slice(0, numberOfSeries).reverse();
    const reversedColorsGradient = this.barService.customColors1.slice(0, numberOfSeries).reverse();
    // Assign color for each series based on its index
    this.seriesData.forEach((series, index) => {
      series.actualColor = reversedColors[index % numberOfSeries];
    });

    // Initialize sumArray with zeros
    this.seriesData[0].data.forEach(() => sumArray.push(0));
    // Sum up values of each series at each index
    this.seriesData.forEach(series => {
      series.data.forEach((value: any, index: any) => {
        if (value > 0) {
          sumArray[index] += value;
        }
      });
    });
    maxDataValue = Math.max(...sumArray);
    maxDataValue = maxDataValue + Math.ceil(maxDataValue * 0.1);

    const tickInterval = Math.ceil(maxDataValue / numberOfTicks); //to calculate the intervals for axis

    // Populate the minArray with initial values
    for (let i = 0; i < this.seriesData[0].data.length; i++) {
      minArray.push(Number.POSITIVE_INFINITY);
    }

    // Iterate over each series and each data point within each series
    this.seriesData.forEach(series => {
      series.data.forEach((value: any, index: any) => {
        // Update the minimum value in minArray
        minArray[index] = Math.min(minArray[index], value);
        // Sum up negative values directly while updating minArray
        if (value < 0) {
          minArray[index] += value; // Subtract negative values to minArray
        }
      });
    });

    let minDataValue = Math.min(...minArray);
    minDataValue = minDataValue - Math.ceil(minDataValue * 0.1);
    yAxisMaxValue = maxDataValue;
    yAxisMinValue = minDataValue;

    //To display plotbands
    if (this.ChartProperties.plotBands) {
      for (let i = 0; i < numPlotBands; i += 2) {
        const from = i + 0.5;
        const to = from + 1;
        plotBandsConfig.push({ color: this.ChartProperties.darkTheme ? this.barService.plotBandsdark : this.barService.plotBandsColor, from, to });
      }
    }

    //set the color of bars
    const globalColorMap = this._configService.getGlobalColorMap();
    
    if (this.ChartProperties.gradientBarColor) {
      this.seriesData.forEach((series, index) => {
        // Extract key after pipe and try to get color from global color map first
        const extractedSeriesName = this.extractKeyAfterPipe(series.name);
        if (globalColorMap && globalColorMap[extractedSeriesName]) {
          series.color = globalColorMap[extractedSeriesName];
        } else {
          series.color = reversedColorsGradient[index % numberOfSeries]; // Assign colors from customColors1
        }
      });
    }
    else if (this.ChartProperties.showPattern) {
      this.seriesData.forEach((series, index) => {
        series.color = this.getPatternForImage(this.barService.patternImages[index % this.barService.PatterncustomColors.length]); // Assign colors in a cyclical manner
      });
    }
    else {
      //applying colors in reverse order since series is reversed to stack from bottom to top
      this.seriesData.forEach((series, index) => {
        // Extract key after pipe and try to get color from global color map first
        const extractedSeriesName = this.extractKeyAfterPipe(series.name);
        if (globalColorMap && globalColorMap[extractedSeriesName]) {
          series.color = globalColorMap[extractedSeriesName];
        } else {
          series.color = reversedColors[index % numberOfSeries];
        }
      });
    }
    
 let popUp = this.popUp;
 const containerEl2 = document.getElementById(container2);
const containerWidth2 = containerEl2 ? containerEl2.offsetWidth : 400;
const numSeries2 = this.seriesData.length;
const numCategories2 = this.chartCategories.length;
const BAR_WIDTH2 = 20;
const BAR_GAP2 = 6;
const GROUP_GAP2 = 25;
const pointPaddingValue2 = BAR_GAP2 / (2 * BAR_WIDTH2);
const groupSlotWidth2 = numSeries2 * (BAR_WIDTH2 + BAR_GAP2);
const groupPaddingValue2 = GROUP_GAP2 / (2 * groupSlotWidth2);
const totalBarsWidth2 = numCategories2 * (numSeries2 * (BAR_WIDTH2 + BAR_GAP2) + GROUP_GAP2);
    setTimeout(() => {
    try { this.chart = Highcharts.chart(container2, {
      
      chart: {
        type: 'column',
        backgroundColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
        style: {
          fontFamily: this.barService.textfont,
          color: this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor,
        }
      },
      exporting: {
        enabled: false
      },

      legend: this.barService.customizeLegend(this.properties.showLegend,this.popUp, this.ChartProperties.legendPosition, this.ChartProperties),
       
      title: {
        text:'',
        align: this.ChartProperties.chartTitlePosition,
        style: {
          color: this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor,
          marginleft: '4%',
          fontFamily: this.barService.textfont,
          fontSize: '2em'
        }
      },

      accessibility: {
        point: {
          valueDescriptionFormat: '{index}. {point.name}, fat: {point.x}g, sugar: {point.y}g, {point.change}g.'
        }
      },
      xAxis: {
        // reversed: true,
        visible: true,
        lineWidth: 1,
        min: 0,
        max: this.chartCategories.length-1,
        categories: this.chartCategories,
        labels: {
          rotation: this.barService.xAxisLabelOrientation(this.ChartProperties.axisLabelOrientation, this.ChartProperties),
          useHTML: popUp,
          style: {
            color: this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor,
            fontSize: popUp ? '0.7rem' : '12px',
            whiteSpace: 'normal',
          },
          formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
            const raw = String(this.value ?? '');
            const esc = (s: string) => s
              .replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/\"/g, '&quot;')
              .replace(/'/g, '&#39;');

            if (popUp) {
              const chart = this.axis.chart;
              const categories = (this.axis.categories || []) as any[];
              const chartWidth = chart.plotWidth || 400;
              const numCategories = Math.max(categories.length, 1);
              const baseWidth = Math.floor(chartWidth / numCategories);
              const padding = 12;
              const minWidth = 120;
              const labelWidth = Math.max(baseWidth - padding, minWidth);

              return `<div style=\"width:${labelWidth}px; white-space:normal; overflow:visible; text-overflow:clip; word-break:break-word; line-height:1.2; text-align:center; margin:0 auto;\" title=\"${esc(raw)}\">${esc(raw)}</div>`;
            }

            return raw;
          },
        },
        scrollbar: {
          enabled: this.chartCategories.length-1 > maxCategoriesToShow ? true : false,
          height: 6, // Adjust the height of the scrollbar as needed
           barBackgroundColor: '#7f7f7f',//#802AB7,
          barBorderRadius: 5,
          barBorderWidth: 0,
          barBorderColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
          buttonBackgroundColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
          buttonBorderWidth: 0,
          buttonArrowColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
          buttonBorderRadius: 5,
          rifleColor: 'none',
          trackBackgroundColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
          trackBorderWidth: 0,
          trackBorderColor: 'black',
          trackBorderRadius: 5,
        },
        tickLength: 0,
        plotBands: plotBandsConfig,
      },
      yAxis: {
          min: previewYMin,
        max: previewYMax,
        visible: false,
        gridLineWidth: this.ChartProperties.gridlines,
        labels: {
          style: {
            color: this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor,
          },
        },
        // plotLines: [{
        //   value: 0,
        //   width: 1,
        //   zIndex: 4,
        //   visible:true
        // }],
        //min: this.min,
        //max: this.max*1.05,
        tickInterval: tickInterval,
        title: {
          text: '',
          fontFamily: this.barService.textfont
        },
        stackLabels: {
          enabled: false,
        },
      },
      credits: {
        enabled: false
      },

        tooltip: {
        enabled: true,
        borderWidth: 1,
        useHTML: true,
       backgroundColor:  'white',
        shadow: false,
       outside: true,
        style: {
           zIndex: 9999,
           backgroundColor: 'white',
          pointerEvents: 'none' // Prevent tooltip from interfering with mouse events
        },

        formatter: function () {
             if (this.series.name === 'Marker1') return false;
          //select tooltip style
          let isDefaultTooltip = properties.toolTipStyle;
          //tooltip border color
          const dotColor = this.color// Get the series color
          const backgroundcolor = '#f5f5f5';
          const backgroundcolor2 = properties.darkTheme ? 'white' : '#ddddd';
          //get the appropriate tooltip according to datalabel property selected
          const text = properties.showDataLabel ? this.series.userOptions.tooltip[this.point.x] : this.y;
 const content =
               `<div style="background: transparent; border: none; border-radius: 8px; min-width: 20px; font-size: 0.8em; display: flex; align-items: center; ">
            <span style="display:inline-block; width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
            <span>${this.point.series.name}: </span>
            <b style="margin-left:4px;">${text}</b>
          </div>`;
 
  return content;
//         if (isDefaultTooltip != 'default') {
//           const content =
//                `<div style="background: transparent; border: none; border-radius: 8px; min-width: 20px; font-size: 0.8em; display: flex; align-items: center; ">
//             <span style="display:inline-block; width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
//             <span>${this.point.series.name}: </span>
//             <b style="margin-left:4px;">${text}</b>
//           </div>`;
 
//   return content;

          
//           }
//       else {
//     const commonContent =
//               `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 999; padding: 2%; border-radius: 5px; margin: 0; background-color :${backgroundcolor2};">` +
             
//               `<span><strong>Category Name:</strong></span> ${this.point.series.name}<br>` +
//               `<span><strong>Value:</strong></span> ${text}`;



//             return commonContent + '</div>';
// }
        },
      } as any,
      plotOptions: {
        series: {
          animation: false,
        },
        column: {
          pointPadding: pointPaddingValue2,
          groupPadding: groupPaddingValue2,
          stacking: undefined,
          shadow: this.ChartProperties.shadow ? {
            color: 'rgba(0, 0, 0, 0.5)',
            offsetX: 1,
            offsetY: 1,
            opacity: 0.5,
            width: 6,
          } : false,
          dataLabels:
          {
            allowOverlap: this.ChartProperties.allowOverlap,
            enabled: this.ChartProperties.showDataLabel,
            color: this.ChartProperties.dataLabelColor == "default" ? (this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor) : this.ChartProperties.dataLabelColor,
            verticalAlign: 'middle',
            align: 'right',
            x: 15,
            useHTML: true,
            style: {
              backgroundColor: 'transparent',
              shadow: false,
              borderWidth: 0,
              textOutline: 'none',
              borderRadius: 0,
              fontSize: this.ChartProperties.dataLabelSize,
              fontFamily: this.barService.textfont,
              fontWeight: "normal"
            },
            formatter: function (this: any) {
              let sigcolor;
              const upwardTriangle = '&#9650';
              const downwardTriangle = '\u25BC';
              const upColor = 'green';
              const downColor = 'red';
              let text; let changeText; let sig; let sColor;
              let finalText = "";

              if (this.series.userOptions.roundedValue[this.point.x] == null || this.series.userOptions.roundedValue[this.point.x] === "") {
                finalText = "NA";
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }

              if (properties.datalabelStyle == "significance + changeVs")
              {
                text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                changeText = this.series.userOptions.changeValue[this.point.x];
                sig = this.series.userOptions.significanceValue[this.point.x];
                sColor = sig > 0 ? upColor : (sig < 0 ? 'red' : '');
                let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                let changeColor = properties.darkTheme ? 'white' : 'black';

                if (parseFloat(changeText) > 0) {
                  changeText = "+" + changeText;
                }

                finalText = (
                  `<div style="display: block; text-align: center;">
                  <div style="display: inline-block; width: 4em; height: 0em; text-align: center;">${text}</div>
                   <br>
                   <div style="display: inline-block; text-align: center; font-size: 80%; color:${changeColor};">(${changeText})</div>
                   <div style="display: inline-block; text-align: center; font-size: 80%; color:${sColor};">${s}</div>
                   </div>`
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }


              if (properties.datalabelStyle == "datalabel") {
                text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                finalText = (
                  '<span >' + text + '</span>'
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;

              }

              if (properties.datalabelStyle == "change") {
                text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                changeText = this.series.userOptions.changeValue[this.point.x];
                sig = this.series.userOptions.significanceValue[this.point.x];

                let changeColor = properties.darkTheme ? 'white' : 'black';

                if (parseFloat(changeText) > 0) {
                  changeText = "+" + changeText;
                }


                finalText = (
                  `<div style="display: block; text-align: center;">
                  <div style="display: inline-block; width: 4em; height: 0em; text-align: center;">${text}</div>
                   <br>
                   <div style="display: inline-block; text-align: center; font-size: 80%; color:${changeColor};">(${changeText})</div>
                   </div>`
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }

              if (properties.datalabelStyle == "significance") {
                text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                sig = this.series.userOptions.significanceValue[this.point.x];
                let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                sigcolor = sig > 0 ? upColor : (sig < 0 ? downColor : '');

                finalText = (
                  '<span >' + text + '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span></span>'
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }

              if (properties.datalabelStyle == "significance2") {
                text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                changeText = this.series.userOptions.changeValue[this.point.x];
                sig = this.series.userOptions.significanceValue[this.point.x];;
                let sig1 = this.series.userOptions.significanceValue2[this.point.x];;
                sColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : properties.darkTheme ? 'white' : 'black');

                if (parseFloat(changeText) > 0) {
                  changeText = "+" + changeText;
                }


                finalText = (
                  `<div style="display: block; text-align: center;">
                  <div style="display: inline-block; width: 4em; height: 0em; text-align: center;">${text}</div>
                   <br>
                   <div style="display: inline-block; text-align: center; font-size: 80%; color:${changeColor};">(${changeText})</div>
                   <div style="display: inline-block; text-align: center; font-size: 80%; color:${sColor};">${s}</div>
                   </div>`
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }

              if (properties.datalabelStyle == 'lowSample') {
                text = parseFloat(this.series.userOptions.sampleSizeValues[this.point.x]) > sampleSizeConstant ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'LS';
                finalText = (
                  '<span>' +
                  text +
                  '</span> ' +
                  '<span style="opacity: 0.5"></span>'
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }
              finalText = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
              this.series.userOptions.tooltip[this.point.x] = finalText;
              return finalText;
            }
          }
        },
      },
      series: this.seriesData
    } as any);
    this.cdr.detectChanges();
  
  
}catch (error) {
      console.error('Error rendering chart:', error);
    }
  }, 0);
  }
}


  applycustomization(event: any, item: string) {
    this.event = event;
    
    //choose the appropriate customization
    this.barService.applycustomization(event,item, this.ChartProperties)
    this.renderChart2('chart-container'+this.id,this.data, this.ChartProperties);
        this.cdr.detectChanges();
  }

  patternselect(ispattern: boolean) {
    this.ChartProperties.showPattern = ispattern
    this.accessSeriesValues(this.ChartProperties.datalabelStyle == 'lowSample');
    this.renderChart2('chart-container',this.data, this.ChartProperties);
  }

  userselectedproperties() {
    this.data["properties"][0].showPattern = this.ChartProperties.showPattern;
    this.data["data"] = this.StackChartData;
    this.data["properties"][0] = this.ChartProperties;
    return JSON.stringify(this.data).toString();
  }

  getPatternForImage(imageUrl: any) {
    return {
      pattern: {
        image: imageUrl,
        aspectRatio: 9 / 4
      }
    };
  }
getPointWidth(container: any, categoryCount: number, isHorizontal: boolean = false): number {
  const containerSize = isHorizontal
    ? (container?.nativeElement?.offsetHeight || 400)
    : (container?.nativeElement?.offsetWidth || 400);

  const seriesCount = this.ChartProperties?.series?.length || 1;
  const totalBars = categoryCount * seriesCount;

  // Each bar gets this much space
  const slotWidth = (containerSize * 0.85) / totalBars;
  
  // Bar takes 60% of its slot — consistent ratio always
  const calculated = Math.floor(slotWidth * 0.5);

  // Cap: never fatter than 50px, never thinner than 15px
  return Math.min(35, Math.max(15, calculated));
}
// getPointWidth(container: any, categoryCount: number): number {
//   const containerHeight = container?.nativeElement?.offsetHeight || 400;
//     // Replace this.chartData with your actual series array
//   const seriesCount = this.ChartProperties?.series?.length      // option 1
//                    || this.properties?.series?.length           // option 2
//                    || 1;

//   // Total slot per category, split across series
//   const slotPerCategory = (containerHeight * 0.85) / Math.max(categoryCount, 1);
//   const barWidth = Math.floor((slotPerCategory / seriesCount) * 0.80);

//   // Cap: never thicker than 50px, never thinner than 8px
//   return Math.min(50, Math.max(8, barWidth));
// }
// private getPointWidth(containerId: string, categoryCount: number): number | undefined {
//   const el = document.getElementById(containerId);
//   if (!el || categoryCount <= 0) return undefined;

//   const plotWidth = el.clientWidth || 800;
//   const perCat = plotWidth / categoryCount;
  
//   // REDUCE pointWidth for multiple series
//   const multiplier = 0.25; // Was 0.18 - reduce for clustering
//   const width = Math.floor(perCat * multiplier);
//   return Math.max(5, Math.min(width, this.popUp ? 40: 25)); // Max 40/30 instead of 60/45
// }
private getStackTotalsMax(series: any[]): number {
  if (!series?.length) return 0;
  const len = series[0]?.data?.length || 0;

  const totals = Array(len).fill(0);

  series.forEach(s => {
    (s.data || []).forEach((v: any, i: number) => {
      const num = typeof v === 'number' ? v : Number(v) || 0;
      if (!isNaN(num)) totals[i] += num;
    });
  });

  return Math.max(...totals, 0);
}

}